import httpClient from './httpClient'

const END_POINT = '/insights'

const InsightsApi = {
  async getSellerOfferInsights(sellerOfferId) {
    const url = `${END_POINT}/offer/${sellerOfferId}`
    return await httpClient.get(url)
  }
}

export default InsightsApi
